/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetSetting } from '../../../../../hooks/useDashboardState'
import { useDashboardWidgetData } from '../../../../../hooks/useWidgetState'
import ErrorMessage from '../../../../share/ErrorMessage'
import { InsightCount } from '../../../../../schemas/action/InsightCountSchema'
import { TrendingWidgetsType } from '../../types'

const TrendingWidgetBelowThresholdGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetSetting = useDashboardWidgetSetting<TrendingWidgetsType>(widgetId)
  const widgetData = useDashboardWidgetData<InsightCount>(widgetId)
  const { t } = useTranslation()

  const entries = widgetData.data[0].results![0].data.insights![0].dataset
  const lastPeriodValues = entries!
    .flatMap((entry) => entry.set)
    .slice(0, widgetSetting.topN)
    .map((entry) => {
      const aggregateValues = entry?.aggregateResult?.values
      return aggregateValues?.length
        ? parseInt(aggregateValues[aggregateValues.length - 1]!, 10)
        : 0
    })

  if (widgetSetting.minCount !== undefined && widgetSetting.minCount !== null) {
    const isBelowThreshold = lastPeriodValues.every((value) => value < widgetSetting.minCount!)
    if (isBelowThreshold) return <ErrorMessage>{t('emptyBecauseLowCount')}</ErrorMessage>
  }

  return children
}

export default TrendingWidgetBelowThresholdGuard
